<ng-container *transloco="let t; read: 'CART_MODAL_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header">
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
      </ion-button>
      <h1>{{ t('TITLE') }}</h1>
      <ion-button (click)="closeAllModals()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </div>
  </ion-toolbar>
  <ion-content class="ion-padding">
    <div
      class="cart-modal-inner flex-column"
      *ngIf="checkedCartDS$ | async as checkedCartDS"
      [class.justify-center]="!!checkedCartDS.error || checkedCartDS.loading"
    >
      <app-pre-loader class="main-loader" *ngIf="checkedCartDS.loading"> </app-pre-loader>

      <app-error-container *ngIf="!checkedCartDS.loading && !!checkedCartDS.error" [errorKey]="checkedCartDS.error.errorKey"> </app-error-container>

      <form
        *ngIf="!checkedCartDS.loading && !checkedCartDS.error && !!checkedCartDS.data"
        [formGroup]="formGroup"
        class="flex-column"
        (ngSubmit)="createOrder()"
      >
        <ng-container *ngIf="accountBalance | isNotNullorUndefined">
          <div class="flex space-between items-center">
            <div class="label">{{ t('ACCOUNT_BALANCE') }} :</div>
            <app-reload-button [link]="['/reload']" (click)="reloadClick()" [forceAlert]="accountBalanceWarning"></app-reload-button>
          </div>
          <app-error-container class="mt-16 mt-16-desktop align-left" *ngIf="accountBalanceWarning" [errorKey]="'SoldeTooLowBadRequest'"> </app-error-container>
        </ng-container>
        @switch (restaurant?.sousType) {
          @case (RestaurantSousTypeValues.Scorp) {
            <div class="flex space-between mt-12 mt-16-desktop">
              <div class="label">{{ t('SCORP_DELIVERY_DATE') }} :</div>
              <div class="data capitalize">{{ checkedCartDS.data.date | translocoDate: { dateStyle: 'full' } }}</div>
            </div>
          }
          @case (RestaurantSousTypeValues.AntiGaspi) {
            <div class="flex space-between mt-12 mt-16-desktop">
              <div class="label">{{ t('ANTIGASPI_PICKUP_BEFORE') }} :</div>
              @if (checkedCartDS.data.pickupLimitDate) {
                <div class="data capitalize">{{ checkedCartDS.data.pickupLimitDate | translocoDate: { timeStyle: 'short' } }}</div>
              }
            </div>
          }
        }
        @if (restaurant?.sousType === RestaurantSousTypeValues.Scorp) {
          <div class="flex space-between mt-12 mt-16-desktop">
            <div class="label">{{ t('SERVICE') }} :</div>
            <div class="data">{{ 'RestaurantServiceValues.' + checkedCartDS.data.service | transloco }}</div>
          </div>
        }

        <ng-container *ngIf="checkedCartDS.data.hasArticlesIncludedInMenu">
          <div class="flex space-between mt-12 mt-16-desktop">
            <div class="label">{{ t('ARTICLES_MENU_FORFAIT') }} :</div>
            <div class="spacer"></div>
            <div class="price font-semibold">
              <app-currency [value]="checkedCartDS.data.menuForfaitPrice"></app-currency>
            </div>
          </div>
          <div *ngIf="checkedCartDS.data.hasArticlesIncludedInMenu" class="cart-item-list mt-12 mt-16-desktop">
            <div class="cart-item" *ngFor="let item of checkedCartDS.data.items | includedInMenu: true; let last = last" (click)="openDishDetails(item.dishId)">
              <div class="cart-item-inner">
                <div>
                  <span class="primary-color font-semibold quantity">{{ item.quantity }}x&nbsp;</span>{{ item.dishLabel }}
                </div>
                <div class="spacer"></div>

                <div *ngIf="item.price" class="price">
                  <app-currency [value]="item.price"></app-currency>
                </div>
              </div>
              <div *ngIf="!last" class="list-divider"></div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="checkedCartDS.data.hasArticlesNotIncludedInMenu || checkedCartDS.data.formulas">
          <div class="flex space-between mt-12 mt-16-desktop">
            <div class="label">{{ t(checkedCartDS.data.hasArticlesIncludedInMenu && !checkedCartDS.data.formulas ? 'EXTRA_ARTICLES' : 'ARTICLES') }} :</div>
            <div class="spacer"></div>
            <div class="price font-semibold">
              <app-currency [value]="checkedCartDS.data.items | includedInMenu: false | sumTotal: checkedCartDS.data.formulas"></app-currency>
            </div>
          </div>
          <div class="cart-item-list mt-12 mt-16-desktop">
            <div class="cart-item" *ngFor="let formula of checkedCartDS.data.formulas; let last = last" (click)="openFormulaDetails(formula)">
              <div class="cart-item-inner">
                <div>
                  <span class="primary-color font-semibold quantity">{{ formula.quantity }}x&nbsp;</span>{{ formula.formulaLabel }}
                </div>
                <div class="spacer"></div>
                <div *ngIf="formula.price" class="price">
                  <app-currency [value]="formula.price"></app-currency>
                </div>
              </div>
              <div class="ml-24 mr-48 formula-dish" *ngFor="let dish of formula.dishes">
                {{ dish.dishLabel }}
              </div>
              <div *ngIf="!last || checkedCartDS.data.items.length > 0" class="list-divider"></div>
            </div>
            <div
              class="cart-item"
              *ngFor="let item of checkedCartDS.data.items | includedInMenu: false; let last = last"
              (click)="openDishDetails(item.dishId)"
            >
              <div class="cart-item-inner">
                <div>
                  <span class="primary-color font-semibold quantity">{{ item.quantity }}x&nbsp;</span>{{ item.dishLabel }}
                </div>
                <div class="spacer"></div>
                <div *ngIf="item.price" class="price">
                  <app-currency [value]="item.price"></app-currency>
                </div>
              </div>
              <div *ngIf="!last" class="list-divider"></div>
            </div>
          </div>
        </ng-container>
        <div class="cart-item-list mt-12 mt-16-desktop">
          <div class="cart-item" *ngIf="checkedCartDS.data.admission | isNotNullorUndefined">
            <div class="cart-item-inner">
              <div class="label">{{ t('ADMISSION') }}</div>
              <div class="spacer"></div>
              <div class="price font-semibold">
                <app-currency [value]="checkedCartDS.data.admission!"></app-currency>
              </div>
            </div>
          </div>
        </div>
        <div class="total flex space-between mt-12 mt-16-desktop label">
          <div>
            <div>{{ t('TOTAL_TTC') }} :</div>
            <div class="tva">({{ t('TVA') }})</div>
          </div>
          <div class="price">
            <app-currency [value]="checkedCartDS.data.totalTTC"></app-currency>
            <div class="total-mention" *ngIf="!checkedCartDS.data.admission && restaurant?.type === RestaurantTypeValues.Scorp">
              {{ t('TOTAL_MENTION') }}
            </div>
          </div>
        </div>
        @if (checkedCartDS.data.deliveryLocations.length > 0) {
          <div class="delivery-location flex-column mt-24 mt-16-desktop">
            @if (restaurant?.sousType === RestaurantSousTypeValues.AntiGaspi) {
              <div class="label">{{ t('PICKUP_LOCATION') }} :</div>
            } @else {
              <div class="label">{{ t('DELIVERY_LOCATION') }} :</div>
            }
            <app-form-control class="control">
              <app-select
                mode="select"
                [label]="'AMOUNT' | transloco"
                formControlName="deliveryLocation"
                [options]="checkedCartDS.data.deliveryLocations"
                [displayFn]="deliveryLocDisplayFn"
                [valueFn]="deliveryLocValueFn"
              >
              </app-select>
            </app-form-control>
          </div>
        }

        <div *ngIf="restaurant?.allowComments" class="flex flex-column mt-24 mt-16-desktop">
          <div class="label">{{ t('COMMENTS_LABEL') }}</div>
          <app-form-control>
            <ion-item class="" fill="outline">
              <ion-textarea #textAreaEl [rows]="4" [placeholder]="t('COMMENTS_PLACEHOLDER')" formControlName="comments"> </ion-textarea>
              <div class="helper" slot="helper" *ngIf="commentsCtrl.valid">{{ textAreaEl.value?.length ?? 0 }}/150</div>
              <div slot="error" *ngIf="commentsCtrl?.dirty && commentsCtrl?.hasError('maxlength')">
                {{ t('COMMENTS_MAXLENGTH') }}
              </div>
              <div slot="error" *ngIf="commentsCtrl?.hasError('required')">
                {{ t('COMMENTS_REQUIRED') }}
              </div>
            </ion-item></app-form-control
          >
        </div>
        <div class="flex items-center justify-center mt-24 mb-12 mt-48-desktop cgv">
          <ion-checkbox slot="start" formControlName="cgv"></ion-checkbox>
          <label id="trigger-button">{{ t('ACCEPT_TOS') }}</label>
        </div>

        <ion-modal [breakpoints]="[0, 1]" [initialBreakpoint]="1" trigger="trigger-button" [isOpen]="false">
          <ng-template>
            <ion-toolbar>
              <div class="toolbar-header">
                <ion-button (click)="dismissModal()" fill="none" color="secondary">
                  <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                </ion-button>
                <div class="spacer"></div>
                <div class="right"></div>
              </div>
            </ion-toolbar>
            <ion-content class="ion-padding">
              <app-scorp-cgv></app-scorp-cgv>
            </ion-content>
          </ng-template>
        </ion-modal>

        <app-error-container class="mt-24 mb-12" *ngIf="createOrderStatus.value === 'error'" [errorKey]="createOrderStatus.error.errorKey">
        </app-error-container>

        <ion-button [disabled]="formGroup.invalid || accountBalanceWarning" type="submit" color="primary" class="mt-12 self-stretch desktop-centered">
          <span>{{ t('VALIDATE') }}</span>
          <app-pre-loader *ngIf="createOrderStatus.value === 'pending'"></app-pre-loader>
        </ion-button>

        <div class="mt-24"></div>
      </form>
    </div>
  </ion-content>
</ng-container>
